// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import WechatOutlineSvg from '@rsuite/icon-font/lib/platform/WechatOutline';
var WechatOutline = createSvgIcon({
  as: WechatOutlineSvg,
  ariaLabel: 'wechat outline',
  category: 'platform',
  displayName: 'WechatOutline'
});
export default WechatOutline;